import payload_plugin_qLmFnukI99 from "/home/runner/work/ticketco-portal/ticketco-portal/node_modules/@pinia/nuxt/dist/runtime/payload-plugin.js";
import revive_payload_client_4sVQNw7RlN from "/home/runner/work/ticketco-portal/ticketco-portal/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/runner/work/ticketco-portal/ticketco-portal/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/runner/work/ticketco-portal/ticketco-portal/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/runner/work/ticketco-portal/ticketco-portal/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/home/runner/work/ticketco-portal/ticketco-portal/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/runner/work/ticketco-portal/ticketco-portal/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/home/runner/work/ticketco-portal/ticketco-portal/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/home/runner/work/ticketco-portal/ticketco-portal/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/home/runner/work/ticketco-portal/ticketco-portal/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/runner/work/ticketco-portal/ticketco-portal/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_tbFNToZNim from "/home/runner/work/ticketco-portal/ticketco-portal/node_modules/@zadigetvoltaire/nuxt-gtm/dist/runtime/plugin.mjs";
import plugin_PSbK9A48ZQ from "/home/runner/work/ticketco-portal/ticketco-portal/node_modules/pinia-plugin-persistedstate/dist/nuxt/runtime/plugin.js";
import switch_locale_path_ssr_5csfIgkrBP from "/home/runner/work/ticketco-portal/ticketco-portal/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/home/runner/work/ticketco-portal/ticketco-portal/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import _00_dates_p1V9LktQ0r from "/home/runner/work/ticketco-portal/ticketco-portal/plugins/00.dates.js";
import _00_fontawesome_j8334SIXNT from "/home/runner/work/ticketco-portal/ticketco-portal/plugins/00.fontawesome.js";
import _00_navigation_ww86oqf811 from "/home/runner/work/ticketco-portal/ticketco-portal/plugins/00.navigation.js";
import _00_utilities_iS7VSXsXDA from "/home/runner/work/ticketco-portal/ticketco-portal/plugins/00.utilities.js";
import _01_countriesAndStatesService_MEket6rhha from "/home/runner/work/ticketco-portal/ticketco-portal/plugins/01.countriesAndStatesService.js";
import _01_eventBus_pJMuKiya6j from "/home/runner/work/ticketco-portal/ticketco-portal/plugins/01.eventBus.js";
import _01_i18n_tuYmYnlJNX from "/home/runner/work/ticketco-portal/ticketco-portal/plugins/01.i18n.js";
import _01_mouseflow_NfZoj7ejd0 from "/home/runner/work/ticketco-portal/ticketco-portal/plugins/01.mouseflow.js";
import _01_postalCodeService_dNQsAJEQmP from "/home/runner/work/ticketco-portal/ticketco-portal/plugins/01.postalCodeService.js";
import _01_sentry_t6z2suMqRh from "/home/runner/work/ticketco-portal/ticketco-portal/plugins/01.sentry.js";
import _02_apiHelper_O3hAeD9v4h from "/home/runner/work/ticketco-portal/ticketco-portal/plugins/02.apiHelper.js";
import _02_cookiesConsent_JxjydqOk7z from "/home/runner/work/ticketco-portal/ticketco-portal/plugins/02.cookiesConsent.js";
import _03_authApiService_UAX3Kq4tqr from "/home/runner/work/ticketco-portal/ticketco-portal/plugins/03.authApiService.js";
import _03_credentialApiService_8sx0taipvk from "/home/runner/work/ticketco-portal/ticketco-portal/plugins/03.credentialApiService.js";
import _03_eventApiService_F9B1mgJejZ from "/home/runner/work/ticketco-portal/ticketco-portal/plugins/03.eventApiService.js";
import _03_ordersApiService_J27E8x202T from "/home/runner/work/ticketco-portal/ticketco-portal/plugins/03.ordersApiService.js";
import _03_userApiService_X6NbZIhl0g from "/home/runner/work/ticketco-portal/ticketco-portal/plugins/03.userApiService.js";
import _04_authService_5f4Bmuevxl from "/home/runner/work/ticketco-portal/ticketco-portal/plugins/04.authService.js";
import _04_credentialService_LXPMvfxXs0 from "/home/runner/work/ticketco-portal/ticketco-portal/plugins/04.credentialService.js";
import _04_eventService_mB9sQblK2h from "/home/runner/work/ticketco-portal/ticketco-portal/plugins/04.eventService.js";
import _04_orderService_66KSPY4Mhu from "/home/runner/work/ticketco-portal/ticketco-portal/plugins/04.orderService.js";
import _04_userService_yKLSa06em5 from "/home/runner/work/ticketco-portal/ticketco-portal/plugins/04.userService.js";
export default [
  payload_plugin_qLmFnukI99,
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_tbFNToZNim,
  plugin_PSbK9A48ZQ,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  _00_dates_p1V9LktQ0r,
  _00_fontawesome_j8334SIXNT,
  _00_navigation_ww86oqf811,
  _00_utilities_iS7VSXsXDA,
  _01_countriesAndStatesService_MEket6rhha,
  _01_eventBus_pJMuKiya6j,
  _01_i18n_tuYmYnlJNX,
  _01_mouseflow_NfZoj7ejd0,
  _01_postalCodeService_dNQsAJEQmP,
  _01_sentry_t6z2suMqRh,
  _02_apiHelper_O3hAeD9v4h,
  _02_cookiesConsent_JxjydqOk7z,
  _03_authApiService_UAX3Kq4tqr,
  _03_credentialApiService_8sx0taipvk,
  _03_eventApiService_F9B1mgJejZ,
  _03_ordersApiService_J27E8x202T,
  _03_userApiService_X6NbZIhl0g,
  _04_authService_5f4Bmuevxl,
  _04_credentialService_LXPMvfxXs0,
  _04_eventService_mB9sQblK2h,
  _04_orderService_66KSPY4Mhu,
  _04_userService_yKLSa06em5
]